import React, { useState, useEffect } from 'react';
import { Map, TileLayer, Polyline, CircleMarker } from 'react-leaflet'; // 👇 Importamos los componentes del mapa

const RouteLibrary = ({ isOpen, onClose, onApplyRoute, activeDrawingDevice }) => {
    const [routes, setRoutes] = useState([]);

    const fetchRoutes = async () => {
        try {
            const token = localStorage.getItem('token');
            const res = await fetch(`${process.env.REACT_APP_API_URL}/routes`, {
                headers: { 'x-access-token': token }
            });
            if (res.ok) {
                const data = await res.json();
                setRoutes(data);
            }
        } catch (e) {
            console.error("Error fetching routes:", e);
        }
    };

    useEffect(() => {
        if (isOpen) fetchRoutes();
    }, [isOpen]);

    const handleDelete = async (id) => {
        if (!window.confirm("Delete this saved path from the library?")) return;
        try {
            const token = localStorage.getItem('token');
            const res = await fetch(`${process.env.REACT_APP_API_URL}/routes/${id}`, {
                method: 'DELETE',
                headers: { 'x-access-token': token }
            });
            if (res.ok) fetchRoutes();
        } catch (e) {
            console.error("Error deleting route:", e);
        }
    };

    // 👇 MAGIA: Función para calcular la caja que envuelve el path y centrar el minimapa
    const getBounds = (waypoints) => {
        if (!waypoints || waypoints.length === 0) return [[0,0], [0,0]];
        const lats = waypoints.map(wp => wp[0]);
        const lons = waypoints.map(wp => wp[1]);
        return [
            [Math.min(...lats), Math.min(...lons)],
            [Math.max(...lats), Math.max(...lons)]
        ];
    };

    return (
        <div className={`alerts-page-wrapper ${isOpen ? 'open' : ''}`}>
            <div className="alerts-header">
                <h2 className="alerts-title">PATH LIBRARY</h2>
                <button className="btn-close-alerts" onClick={onClose}>
                    <i className="fa-solid fa-times"></i>
                </button>
            </div>
            
            <div className="logs-grid" style={{ padding: '10px' }}>
                {routes.length === 0 ? (
                    <div style={{color: '#888', textAlign: 'center', marginTop: '40px', fontFamily: 'monospace', letterSpacing: '1px'}}>
                        NO SAVED PATHS
                    </div>
                ) : (
                    routes.map((route, i) => {
                        const bounds = getBounds(route.waypoints);
                        
                        return (
                            <div key={i} className="asset-card" style={{ padding: 0, overflow: 'hidden', border: '1px solid #333' }}>
                                
                                {/* 👇 MINIMAPA DE PREVISUALIZACIÓN 👇 */}
                                <div style={{ height: '140px', width: '100%', position: 'relative', backgroundColor: '#e5e3df' }}>
                                    
                                    {/* Insignia con el nombre flotando sobre el mapa */}
                                    <div style={{ position: 'absolute', top: '10px', left: '10px', zIndex: 1000 }}>
                                        <span className="tactical-badge active" style={{ backgroundColor: 'rgba(26,26,26,0.85)', color: '#00bcd4', border: '1px solid #00bcd4', backdropFilter: 'blur(2px)' }}>
                                            {route.name.toUpperCase()}
                                        </span>
                                    </div>

                                    {/* Botón de borrar flotando sobre el mapa */}
                                    <button 
                                        className="btn-action-icon deny" 
                                        style={{ position: 'absolute', top: '10px', right: '10px', zIndex: 1000, width: '28px', height: '28px', backgroundColor: 'rgba(26,26,26,0.85)', border: '1px solid #ff3333' }} 
                                        onClick={() => handleDelete(route._id)} 
                                        title="Delete Path"
                                    >
                                        <i className="fa-solid fa-trash" style={{fontSize: '12px'}}></i>
                                    </button>

                                    {/* El mapa estático (bloqueado para que el usuario no lo mueva sin querer) */}
                                    <Map 
                                        bounds={bounds} 
                                        boundsOptions={{ padding: [20, 20] }} // Margen para que el dibujo no toque los bordes
                                        zoomControl={false} 
                                        dragging={false} 
                                        scrollWheelZoom={false} 
                                        doubleClickZoom={false} 
                                        touchZoom={false}
                                        attributionControl={false}
                                        style={{ height: '100%', width: '100%', zIndex: 1 }}
                                    >
                                        <TileLayer url="https://a.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png" />
                                        
                                        {/* Dibujamos el Path */}
                                        <Polyline positions={route.waypoints} color="#1a1a1a" weight={4} opacity={0.8} dashArray="8, 8" lineJoin="round" />
                                        
                                        {/* Punto de inicio */}
                                        {route.waypoints.length > 0 && (
                                            <CircleMarker center={route.waypoints[0]} radius={5} color="#1a1a1a" fillColor="#111" fillOpacity={1} />
                                        )}
                                    </Map>
                                </div>

                                {/* 👇 BOTONERA INFERIOR (DOS BOTONES SI HAY DRON SELECCIONADO) 👇 */}
                                <div style={{ padding: '15px', backgroundColor: '#1a1a1a' }}>
                                    {!activeDrawingDevice ? (
                                        <button 
                                            className="btn-pill cooldown-state" 
                                            style={{ width: '100%', height: '38px', backgroundColor: '#111', borderColor: '#333', color: '#555', fontSize: '12px', animation: 'none' }} 
                                            disabled
                                        >
                                            SELECT A DRONE IN SPOT MODE
                                        </button>
                                    ) : (
                                        <div style={{ display: 'flex', gap: '10px' }}>
                                            
                                            {/* BOTÓN 1: RELATIVO (Se pega al dron) */}
                                            <button 
                                                className="btn-pill" 
                                                style={{
                                                    flex: 1, 
                                                    height: '38px', 
                                                    backgroundColor: 'rgba(0, 188, 212, 0.1)', 
                                                    borderColor: '#00bcd4', 
                                                    color: '#00bcd4',
                                                    animation: 'none',
                                                    fontSize: '11px',
                                                    letterSpacing: '0.5px',
                                                    padding: '0 5px'
                                                }} 
                                                onClick={() => {
                                                    onApplyRoute(route, false); // false = Relativo
                                                    onClose();
                                                }}
                                                title="Apply pattern starting at the drone's current location"
                                            >
                                                <i className="fa-solid fa-crosshairs" style={{marginRight: '5px'}}></i>
                                                AT DRONE
                                            </button>

                                            {/* BOTÓN 2: ABSOLUTO (Posición original) */}
                                            <button 
                                                className="btn-pill" 
                                                style={{
                                                    flex: 1, 
                                                    height: '38px', 
                                                    backgroundColor: 'rgba(255, 152, 0, 0.1)', // Naranja Táctico
                                                    borderColor: '#ff9800', 
                                                    color: '#ff9800',
                                                    animation: 'none',
                                                    fontSize: '11px',
                                                    letterSpacing: '0.5px',
                                                    padding: '0 5px'
                                                }} 
                                                onClick={() => {
                                                    onApplyRoute(route, true); // true = Absoluto
                                                    onClose();
                                                }}
                                                title="Apply pattern at its exact original map coordinates"
                                            >
                                                <i className="fa-solid fa-map-pin" style={{marginRight: '5px'}}></i>
                                                ORIGINAL
                                            </button>
                                            
                                        </div>
                                    )}
                                </div>
                            </div>
                        );
                    })
                )}
            </div>
        </div>
    );
}

export default RouteLibrary;